export default {
  computed: {
    paymentCardChoice () {
      return [
        {
          value: 'savedCard',
          label: this.$t('paymentModal.paymentChoice.savedCards')
        },
        {
          value: 'newCard',
          label: this.$t('paymentModal.paymentChoice.newCard')
        }
      ]
    }
  }
}
